import { decisionFromScore } from "@/lib/scoring";

const styles = {
  fonce: "text-[#00E676] bg-[#00E676]/10 border-[#00E676]/25",
  investis: "text-[#FFCC00] bg-[#FFCC00]/10 border-[#FFCC00]/25",
  ignore: "text-[#FF3B30] bg-[#FF3B30]/10 border-[#FF3B30]/25",
};

export default function DecisionBadge({ score, size = "md" }) {
  const d = decisionFromScore(score);
  const cls = styles[d.color];
  const sz = size === "sm"
    ? "text-[10px] px-2 py-0.5"
    : size === "lg"
    ? "text-sm px-3 py-1.5"
    : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border ${cls} ${sz} font-medium tracking-wide uppercase`}
      data-testid="decision-badge"
    >
      {d.label}
    </span>
  );
}
